import React from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export default function CommunityStrengthening({ nextStep, prevStep }) {
  return (
    <>
      <div className="form-navigator-body">
        <div className="row">
          <div className="col-lg-6">
            <h5>District-CRG constituted</h5>
          </div>
          <div className="row">
          <div className="col-lg-4">
            <div className="form-group">
              <label>Select</label>
              <div class="custom-select">
                <select
                  class="form-control"
                  id="constitutedSelect"
                  name="constituted"
                >
                  <option value="" selected="">
                    Select constituted
                  </option>
                  <option value="" selected="Yes">
                    Yes
                  </option>
                  <option value="" selected="No">
                    No
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="form-group">
              <label>If Yes, date of notification (dd/mm/yyyy)</label>
              <input type="text" placeholder="Enter Date" />
            </div>
          </div>
        </div>
        </div>

        {/* section 1 */}
        <div className="secTitle">
          <h5>If Yes, Number of District CRG Meetings Conducted</h5>
        </div>

        <div className="row">
          <div className="col">
            <div className="form-group">
              <label>Reported during the month</label>
              <input
                type="text"
                placeholder="Enter Reported during the month"
              />
            </div>
          </div>
          <div className="col">
            <div className="form-group">
              <label>Cumulative for FY</label>
              <input type="text" placeholder="Enter Cumulative for FY" />
            </div>
          </div>
          <div className="col">
            <div className="form-group">
              <label>Remarks</label>
              <input type="text" placeholder="Enter Remarks" />
            </div>
          </div>
        </div>

        {/* section 2 */}
        <div className="secTitle">
          <h5>No of issues identified in District CRG meeting</h5>
        </div>

        <div className="row">
          <div className="col">
            <div className="form-group">
              <label>Reported during the month</label>
              <input
                type="text"
                placeholder="Enter Reported during the month"
              />
            </div>
          </div>
          <div className="col">
            <div className="form-group">
              <label>Cumulative for FY</label>
              <input type="text" placeholder="Enter Cumulative for FY" />
            </div>
          </div>
          <div className="col">
            <div className="form-group">
              <label>Remarks</label>
              <input type="text" placeholder="Enter Remarks" />
            </div>
          </div>
        </div>

        {/* section 3 */}
        <div className="secTitle">
          <h5>No of issues resolved</h5>
        </div>

        <div className="row">
          <div className="col">
            <div className="form-group">
              <label>Reported during the month</label>
              <input
                type="text"
                placeholder="Enter Reported during the month"
              />
            </div>
          </div>
          <div className="col">
            <div className="form-group">
              <label>Cumulative for FY</label>
              <input type="text" placeholder="Enter Cumulative for FY" />
            </div>
          </div>
          <div className="col">
            <div className="form-group">
              <label>Remarks</label>
              <input type="text" placeholder="Enter Remarks" />
            </div>
          </div>
        </div>

        {/* section 4 */}
        <div className="secTitle">
          <h5>No of issues escalated to state-CRG</h5>
        </div>

        <div className="row">
          <div className="col">
            <div className="form-group">
              <label>Reported during the month</label>
              <input
                type="text"
                placeholder="Enter Reported during the month"
              />
            </div>
          </div>
          <div className="col">
            <div className="form-group">
              <label>Cumulative for FY</label>
              <input type="text" placeholder="Enter Cumulative for FY" />
            </div>
          </div>
          <div className="col">
            <div className="form-group">
              <label>Remarks</label>
              <input type="text" placeholder="Enter Remarks" />
            </div>
          </div>
        </div>

        {/* section 5 */}
        <div className="secTitle">
          <h5>No of Community Champions Engaged</h5>
        </div>

        <div className="row">
          <div className="col">
            <div className="form-group">
              <label>Reported during the month</label>
              <input
                type="text"
                placeholder="Enter Reported during the month"
              />
            </div>
          </div>
          <div className="col">
            <div className="form-group">
              <label>Cumulative for FY</label>
              <input type="text" placeholder="Enter Cumulative for FY" />
            </div>
          </div>
          <div className="col">
            <div className="form-group">
              <label>Remarks</label>
              <input type="text" placeholder="Enter Remarks" />
            </div>
          </div>
        </div>
      </div>

      <div className="form-navigate-footer">
        <button onClick={prevStep} className="btn btn-outline-secondary">
          Back
        </button>
        <button onClick={nextStep} className="btn btn-dark border-0">
          Next
        </button>
      </div>
    </>
  );
}
